import React, { useEffect, useRef, useState } from 'react';
import '../../CSS/Global.css';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate, Link, useParams } from 'react-router-dom';
import axios from 'axios';
import Sidebar from '../SideBar';
import { useSidebar } from '../../SidebarContext';
import Header from '../Header';
import Select from 'react-select';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import ImageModalEquip from '../Modal/ImageModalProd';
import ImageModalDownloadable from '../Modal/ImageModalDownloadble';
import ImageModalGallery from '../Modal/ImageModalGallery';
import { getDecryptedUserFromCookie } from '../utils/getCookie';
import { decryptToken } from '../utils/getToken';

function convertToWords(num) {
    num = Number(num);
    if (isNaN(num) || num <= 0) return '';
    const a = [
        '', 'One', 'Two', 'Three', 'Four', 'Five', 'Six',
        'Seven', 'Eight', 'Nine', 'Ten', 'Eleven', 'Twelve',
        'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen',
        'Eighteen', 'Nineteen'
    ];
    const b = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

    const numberToWords = (n) => {
        if (n < 20) return a[n];
        if (n < 100) return b[Math.floor(n / 10)] + (n % 10 ? " " + a[n % 10] : "");
        if (n < 1000) return a[Math.floor(n / 100)] + " Hundred" + (n % 100 ? " and " + numberToWords(n % 100) : "");
        if (n < 100000) return numberToWords(Math.floor(n / 1000)) + " Thousand" + (n % 1000 ? " " + numberToWords(n % 1000) : "");
        if (n < 10000000) return numberToWords(Math.floor(n / 100000)) + " Lakh" + (n % 100000 ? " " + numberToWords(n % 100000) : "");
        return numberToWords(Math.floor(n / 10000000)) + " Crore" + (n % 10000000 ? " " + numberToWords(n % 10000000) : "");
    };

    return numberToWords(Number(num));
}


const AffiliateProductEdit = () => {

    const { id } = useParams()
    const user = getDecryptedUserFromCookie("gta_mainstateuser");
    const [keyFeatureInput, setKeyFeatureInput] = useState('');
    const [specInput, setSpecInput] = useState({ label: '', value: '' });
    const url = process.env.REACT_APP_LINK

    const [formData, setFormData] = useState({
        image: [],
        gallery: [],
        title: '',
        sku: "",
        originalPrice: '',
        discountPrice: '',
        product_type: { value: 'Affiliate Product', label: 'Affiliate Product' },
        category: null,
        categorytype: "",
        total: '',
        stock: '',
        status: null,
        short_description: "",
        description: "",
        product_url: "",
        button_text: "",
        stock: "",
        weight: "",
        length: "",
        width: "",
        height: "",
        user_id: "",
        user_name: "",
        delivery_days: "",
        key_features: [],
        specifications: [],
        category_id: ""
    });
    const [availableSizes] = useState(["XS", "S", "M", "L", "XL", "XXL"]);
    const [selectedSizes, setSelectedSizes] = useState([]);
    const [variationsAccordion, setVariationsAccordion] = useState([]);
    const [showVariations, setShowVariations] = useState(false);
    const [errors, setErrors] = useState({});
    const [activeIndex, setActiveIndex] = useState(null);
    const [categories, setCategories] = useState([]);
    const token = decryptToken("accessToken") || ""

    const toggleAccordion = (index) => {
        setActiveIndex(prevIndex => (prevIndex === index ? null : index));
    };

    const isValidURL = (url) => {
        try {
            const parsed = new URL(url);
            return parsed.protocol === "http:" || parsed.protocol === "https:";
        } catch (e) {
            return false;
        }
    };

    const fetchCategories = async () => {
        try {
            const response = await fetch(`${url}/category/getdata/category/${user.main_id}`, {
                method: "GET",
                // credentials: "include"
            })
            const res = await response.json();
            const options = res.map(cat => ({
                value: cat.category || cat.category || cat.id,
                label: cat.category || cat.category || cat.category,
                id: cat.id
            }));
            setCategories(options);
        } catch (error) {
            console.error(error)
        }
    }



    const updateVariation = (index, field, value) => {
        setVariations(prev => {
            const updated = [...prev];
            updated[index] = { ...updated[index], [field]: value };
            return updated;
        });
    };


    const updateTypeofCat = (key, isChecked) => {
        let updatedTypes = (formData.categorytype || "").split(',').filter(Boolean);


        if (key === 'Best Sellers' && isChecked) {
            // Add 'virtual', remove 'downloadable'
            updatedTypes = ['Best Sellers'];
        } else if (key === 'Trending' && isChecked) {
            // Add 'downloadable', remove 'virtual'
            updatedTypes = ['Trending'];
        } else {
            // Remove the key from selection
            updatedTypes = updatedTypes.filter(type => type !== key);
        }

        setFormData((prev) => ({
            ...prev,
            categorytype: updatedTypes.join(',')
        }));
    };

    const attributeOptions = [
        { value: 'size', label: 'Size' },
        { value: 'weight', label: 'Weight' },
        { value: 'length', label: 'Length' },
        { value: 'thickness', label: 'Thickness' },
        // Add more as needed
    ];

    const sizeOptions = [
        { value: 'S', label: 'S' },
        { value: 'M', label: 'M' },
        { value: 'L', label: 'L' },
        { value: 'XL', label: 'XL' },
        { value: 'XXL', label: 'XXL' },
    ];

    const WeightOptions = [
        { value: '30 kg', label: '30 kg' },
        { value: '50 kg', label: '50 kg' },

    ]


    const [showImageModal, setShowImageModal] = useState(false);
    const [images, setImages] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const [showImageModalGallery, setShowImageModalGallery] = useState(false);
    const [imagesGallery, setImagesGallery] = useState([]);


    const [isUploadModalOpen, setUploadModalOpen] = useState(false);


    const [variations, setVariations] = useState([]);
    const navigate = useNavigate();

    const handleImageView = async () => {
        const all = await axios.get(`${url}/api/images`);
        setImages((all.data).reverse());
    }

    const statusOptions = [
        { value: 'Active', label: 'Active' },
        { value: 'Inactive', label: 'Inactive' },
    ];

    const categoryOptions = [
        { value: 'electronics', label: 'Electronics' },
        { value: 'fashion', label: 'Fashion' },
        { value: 'home', label: 'Home' },
        { value: 'books', label: 'Books' },
    ];

    const ProductOptions = [
        { value: 'Simple Product', label: 'Simple Product' },
        { value: 'Grouped Product', label: 'Grouped Product' },
        { value: 'Affiliate Product', label: 'Affiliate Product' },
        { value: 'Variable Product', label: 'Variable Product' },
    ];

    const StockOptions = [
        { value: 'In stock', label: 'In stock' },
        { value: 'Out of stock', label: 'Out of stock' },
        { value: 'Unlimited Stock', label: 'Unlimited Stock' },
    ];

    // const handleChange = (e) => {
    //     const { id, value } = e.target;
    //     setFormData((prev) => ({ ...prev, [id]: value }));
    // };
    const handleChange = (e) => {
        const { id, value } = e.target;

        setFormData((prev) => ({ ...prev, [id]: value }));

        // Instant validation for product_url
        if (id === 'product_url') {
            if (!isValidURL(value)) {
                setErrors((prev) => ({ ...prev, product_url: 'Invalid url' }));
            } else {
                setErrors((prev) => ({ ...prev, product_url: null }));
            }
        }

        // Instant validation for price
        if (id === 'discountPrice' && Number(value) > Number(formData.originalPrice)) {
            setErrors((prev) => ({ ...prev, discountPrice: 'Sale price cannot be greater than original price' }));
        } else if (id === 'discountPrice') {
            setErrors((prev) => ({ ...prev, discountPrice: null }));
        }

        if (id === 'originalPrice' && Number(formData.discountPrice) > Number(value)) {
            setErrors((prev) => ({ ...prev, discountPrice: 'Sale price cannot be greater than original price' }));
        }
    };



    const handleSelectChange = (selectedOption, { name }) => {
        setFormData((prev) => ({
            ...prev,
            [name]: selectedOption,              // keeps {value: "Electronics", label: "Electronics", id: 5}
            category_id: selectedOption?.id || "" // 👈 stores actual id
        }));
    };


    const handleSubmit = async (e) => {
        e.preventDefault();

        const newErrors = {};
        if (parseFloat(formData.discountPrice) > parseFloat(formData.originalPrice)) {
            newErrors.price = 'Sale price cannot be greater than original price.';
        }
        if (!isValidURL(formData.product_url)) {
            newErrors.url = 'Product URL is not valid.';
        }

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            toast.error("Please fix the errors before submitting.");
            return;
        }

        try {
            const payload = {
                ...formData,
                image: typeof formData.image[0] === 'string'
                    ? formData.image[0]
                    : formData.image[0]?.url || "",
                product_type: formData.product_type?.value || "", // ✅ Convert to string
                status: formData.status?.value || "",
                stock: formData.stock?.value || "",
                category: formData.category?.value || "",
                user_id: user.main_id,
                user_name: user.full_name,
            };

            const response = await fetch(`${url}/affiliate-product/${id}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(payload)
            });
            const res = await response.json();
            if (response.ok) {
                navigate("/products")
                toast.success("Product Updated successfully", {
                    position: "top-center",
                    autoClose: 2000
                });
            } else {
                toast.warning(res.message)
                console.error("Failed to submit product");
            }
            //   await axios.post("${url}/api/products", formData);
            //   toast.success("Product saved successfully!");
        } catch (error) {
            toast.error("Error saving product.");
            console.error(error);
        }
    };

    useEffect(() => {
        const fetchSingleProduct = async () => {
            try {
                const response = await axios.get(`${url}/grouped-product/single/${id}`);
                const data = response.data;

                setFormData({
                    ...data,
                    product_type: { label: data.product_type, value: data.product_type },
                    category: { label: data.category, value: data.category },
                    status: { label: data.status, value: data.status },
                    stock: { label: data.stock, value: data.stock },
                    image: data.image ? [data.image] : [],
                    gallery: data.gallery || [],
                    key_features: data.key_features || [],
                    specifications: data.specifications || [],

                });

                // Set variations



            } catch (error) {
                console.error("Error fetching product:", error);
                toast.error("Failed to fetch product data");
            }
        };

        fetchSingleProduct();
    }, [id]);

    const handleNavigate = (url) => {
        navigate(url)
    };

    useEffect(() => {
        handleImageView()
        fetchCategories()
    }, [])
    return (
        <>
            <div className="oms-header">
                <h1 className="dashboard-title">Affiliate Product</h1>
                <Link to="/products" className="dashboard-p-form">
                    View Product
                </Link>
                <div className="property-dropdown-wrapper">
                    <button type='button' className="oms-add-btn" onClick={() => setIsOpen(!isOpen)}>
                        Add Products
                    </button>
                    {isOpen && (
                        <ul className="property-dropdown-menu">
                            <li onClick={() => handleNavigate('/simple-product')}>
                                Simple Product
                            </li>
                            {/* <li onClick={() => handleNavigate('/grouped-product')}>
                                    Grouped Product
                                </li>
                                <li onClick={() => handleNavigate('/external-affiliate-product')}>
                                    Affiliate Product
                                </li> */}
                            <li onClick={() => handleNavigate('/variable-product')}>
                                Variable Product
                            </li>
                        </ul>
                    )}
                </div>
            </div>
            <form className="oms-modal-form property-form"
                // className="oms-modal-form"
                onSubmit={handleSubmit}
            >


                <div className='oms-givepaddingfrom'>
                    {/* <div className="oms-form-group">
                            <label htmlFor="category" className="oms-form-label">
                                Product Type
                            </label>
                            <Select
                                options={ProductOptions}
                                placeholder="Select Product Type"
                                name="product_type"
                                value={formData.product_type}
                                onChange={handleSelectChange}
                                isDisabled
                            />
                        </div> */}
                    {/* Image Upload */}




                    {/* Title */}
                    <div className="oms-form-group">
                        <label htmlFor="title" className="oms-form-label">
                            Name
                        </label>
                        <input
                            type="text"
                            id="title"
                            placeholder="Enter title"
                            value={formData.title}
                            onChange={handleChange}
                        />
                    </div>


                    <div className="oms-form-group">
                        <label htmlFor="description" className="oms-form-label">
                            Description
                        </label>
                        <ReactQuill
                            theme="snow"
                            value={formData.description}
                            onChange={(value) =>
                                setFormData((prev) => ({ ...prev, description: value }))
                            }
                            style={{ backgroundColor: "#fefffc" }}
                            placeholder="Enter Description"
                        />
                    </div>

                    {/* Product Image Upload */}
                    <div className="oms-form-group">
                        <label className="oms-form-label">Product Image</label>

                        {/* Button to open image modal */}
                        <button
                            type="button"
                            className="image-upload-btn"
                            onClick={() => setShowImageModal(true)}
                        >
                            Choose Image
                        </button>


                        {/* Preview selected image */}
                        {formData.image.length > 0 && (
                            <div className="selected-image-preview">
                                <img
                                    src={formData.image[0]?.url ? `${url}${formData.image[0].url}` : `${url}${formData.image[0]}`}
                                    alt="Selected"
                                    style={{ width: "100px", height: "100px", objectFit: "cover", marginTop: "10px", border: "1px solid #ccc" }}
                                />
                                <p
                                    className='delete-btnomsprod'
                                    onClick={() => setFormData((prev) => ({ ...prev, image: [] }))}

                                >
                                    <i class="fa-solid fa-xmark"></i>
                                </p>
                            </div>
                        )}
                    </div>

                    <ImageModalEquip
                        show={showImageModal}
                        handleClose={() => setShowImageModal(false)}
                        images={images}
                        onImageSelect={(img) =>
                            setFormData((prev) => ({ ...prev, image: [img] }))
                        }
                        multiple={false}
                        setImages={setImages}
                    />

                    <div className="oms-form-group">
                        <label className="oms-form-label">Product Gallery</label>
                        <button
                            type="button"
                            className="image-upload-btn"
                            onClick={() => setShowImageModalGallery(true)}
                        >
                            Add Gallery Images
                        </button>

                        {/* Preview selected gallery images */}
                        <div className="gallery-preview">
                            {formData.gallery.map((img, index) => (
                                <div key={index} style={{ display: 'inline-block', marginRight: 10, position: 'relative' }}>
                                    <img
                                        src={img?.url ? `${url}${img.url}` : img}
                                        alt="gallery"
                                        style={{ width: "80px", height: "80px", objectFit: "cover", border: "1px solid #ccc" }}
                                    />
                                    <button
                                        type="button"
                                        onClick={() => {
                                            setFormData(prev => ({
                                                ...prev,
                                                gallery: prev.gallery.filter((_, i) => i !== index)
                                            }));
                                        }}
                                        style={{ position: 'absolute', top: 0, right: 0, background: 'red', color: '#fff', border: 'none' }}
                                    >
                                        ×
                                    </button>
                                </div>
                            ))}
                        </div>
                    </div>
                    <ImageModalGallery
                        show={showImageModalGallery}
                        handleClose={() => setShowImageModalGallery(false)}
                        images={images}
                        multiple={true} // ⬅️ set to true for gallery
                        setImages={setImages}
                        onImageSelect={(imgs) => {
                            setFormData((prev) => ({
                                ...prev,
                                gallery: Array.isArray(imgs) ? [...prev.gallery, ...imgs] : [...prev.gallery, imgs]
                            }));
                        }}
                    />
                    <div className="oms-form-group">
                        <label htmlFor="description" className="oms-form-label">
                            Short  Description
                        </label>
                        <ReactQuill
                            theme="snow"
                            value={formData.short_description}
                            onChange={(value) =>
                                setFormData((prev) => ({ ...prev, short_description: value }))
                            }
                            placeholder="Enter Short Description"
                        />
                    </div>


                    {/* Original Price */}
                    <div className="oms-form-group">
                        <label htmlFor="originalPrice" className="oms-form-label">
                            Original Price
                        </label>
                        <input
                            type="number"
                            id="originalPrice"
                            placeholder="Enter original price"
                            value={formData.originalPrice}
                            onChange={handleChange}
                            onWheel={(e) => e.target.blur()}
                        />
                    </div>

                    {/* Discount Price */}
                    <div className="oms-form-group">
                        <label htmlFor="discountPrice" className="oms-form-label">Sale Price</label>
                        <input
                            type="number"
                            id="discountPrice"
                            placeholder="Enter Sale price"
                            value={formData.discountPrice}
                            onChange={handleChange}
                            onWheel={(e) => e.target.blur()}
                        />
                        {errors.discountPrice && <small className="text-dangeraffialate">{errors.discountPrice}</small>}

                    </div>


                    <div className="oms-form-group">
                        <label htmlFor="product_url" className="oms-form-label">Product URL</label>
                        <input
                            type="text"
                            id="product_url"
                            placeholder="Enter Product URL"
                            value={formData.product_url}
                            onChange={handleChange}
                        />
                        {errors.product_url && <small className="text-dangeraffialate">{errors.product_url}</small>}
                    </div>


                    <div className="oms-form-group">
                        <label htmlFor="discountPrice" className="oms-form-label">
                            Button Text
                        </label>
                        <input
                            type="text"
                            id="button_text"
                            placeholder="Enter Button Text"
                            value={formData.button_text}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="oms-form-group">
                        <label htmlFor="title" className="oms-form-label">
                            SKU No
                        </label>
                        <input
                            type="text"
                            id="sku"
                            placeholder="Enter SKU No"
                            value={formData.sku}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="oms-form-group">
                        <label htmlFor="category" className="oms-form-label">
                            Stock Status
                        </label>
                        <Select
                            options={StockOptions}
                            placeholder="Select Stock Status"
                            name="stock"
                            value={formData.stock}
                            onChange={handleSelectChange}
                        />
                    </div>

                    {
                        formData.stock.value === "Unlimited Stock" ? null :
                            <div className="oms-form-group">
                                <label htmlFor="total" className="oms-form-label">
                                    Total Stock
                                </label>
                                <input
                                    type="number"
                                    id="total"
                                    placeholder="Enter Total Stock"
                                    value={formData.total}
                                    onChange={handleChange}
                                    onWheel={(e) => e.target.blur()}
                                />
                            </div>
                    }

                    <div className="oms-form-group">
                        <label htmlFor="discountPrice" className="oms-form-label">
                            Weight
                        </label>
                        <input
                            type="number"
                            id="weight"
                            placeholder="Enter Weight"
                            value={formData.weight}
                            onChange={handleChange}
                            onWheel={(e) => e.target.blur()}
                        />
                    </div>


                    <div className="oms-form-group">
                        <label className="oms-form-label">Dimensions (cm)</label>
                        <div className="oms-dimensions-row">
                            <input
                                type="number"
                                placeholder="Length"
                                value={formData.length}
                                onChange={(e) => setFormData({ ...formData, length: e.target.value })}
                                onWheel={(e) => e.target.blur()}
                            />
                            <input
                                type="number"
                                placeholder="Width"
                                value={formData.width}
                                onChange={(e) => setFormData({ ...formData, width: e.target.value })}
                                onWheel={(e) => e.target.blur()}
                            />
                            <input
                                type="number"
                                placeholder="Height"
                                value={formData.height}
                                onChange={(e) => setFormData({ ...formData, height: e.target.value })}
                                onWheel={(e) => e.target.blur()}
                            />
                        </div>
                    </div>
                    {/* Key Features */}
                    <div className="oms-form-group">
                        <label className="oms-form-label">Key Features</label>
                        <div style={{ display: "flex", gap: "10px", marginBottom: "10px" }}>
                            <input
                                type="text"
                                className="oms-input"
                                placeholder="Enter key feature"
                                value={keyFeatureInput}
                                onChange={(e) => setKeyFeatureInput(e.target.value)}
                            />
                            <button
                                type="button"
                                className="oms-add-btn"
                                onClick={() => {
                                    if (keyFeatureInput.trim()) {
                                        setFormData((prev) => ({
                                            ...prev,
                                            key_features: [...prev.key_features, keyFeatureInput.trim()],
                                        }));
                                        setKeyFeatureInput('');
                                    }
                                }}
                            >
                                Add
                            </button>
                        </div>
                        <ul className="oms-tag-list">
                            {(formData?.key_features || []).map((feature, index) => (
                                <li key={index} className="oms-tag-item">
                                    {feature}
                                    <button
                                        type="button"
                                        className="oms-tag-delete"
                                        onClick={() => {
                                            setFormData((prev) => ({
                                                ...prev,
                                                key_features: prev.key_features.filter((_, i) => i !== index),
                                            }));
                                        }}
                                    >
                                        ×
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Specifications Section */}
                    {/* Specifications */}
                    <div className="oms-form-group">
                        <label className="oms-form-label">Specifications</label>
                        <div style={{ display: "flex", gap: "10px", marginBottom: "10px", flexWrap: "wrap" }}>
                            <input
                                type="text"
                                className="oms-input"
                                placeholder="Label"
                                value={specInput.label}
                                onChange={(e) => setSpecInput((prev) => ({ ...prev, label: e.target.value }))}
                            />
                            <input
                                type="text"
                                className="oms-input"
                                placeholder="Value"
                                value={specInput.value}
                                onChange={(e) => setSpecInput((prev) => ({ ...prev, value: e.target.value }))}
                            />
                            <button
                                type="button"
                                className="oms-add-btn"
                                onClick={() => {
                                    if (specInput.label.trim() && specInput.value.trim()) {
                                        setFormData((prev) => ({
                                            ...prev,
                                            specifications: [...prev.specifications, specInput],
                                        }));
                                        setSpecInput({ label: '', value: '' });
                                    }
                                }}
                            >
                                Add
                            </button>
                        </div>

                        <ul className="oms-tag-list">
                            {(formData?.specifications || []).map((spec, index) => (
                                <li key={index} className="oms-tag-item">
                                    <strong>{spec.label}:</strong> {spec.value}
                                    <button
                                        type="button"
                                        className="oms-tag-delete"
                                        onClick={() => {
                                            setFormData((prev) => ({
                                                ...prev,
                                                specifications: prev.specifications.filter((_, i) => i !== index),
                                            }));
                                        }}
                                    >
                                        ×
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>
                    {/* Category */}
                    <div className="oms-form-group">
                        <label htmlFor="category" className="oms-form-label">
                            Category
                        </label>
                        <Select
                            options={categories}
                            placeholder="Select category"
                            name="category"
                            value={formData.category}
                            onChange={handleSelectChange}
                        />
                    </div>

                    <div className="oms-form-group">
                        <label className="oms-form-label">Choose Home Category</label>
                        <div className="oms-checkbox-group">
                            <div className="oms-checkbox-item">
                                <input
                                    type="checkbox"
                                    id="Best Sellers"
                                    checked={formData.categorytype?.includes("Best Sellers")}
                                    onChange={(e) => updateTypeofCat("Best Sellers", e.target.checked)}
                                />
                                <label htmlFor="Best Sellers">Best Sellers</label>
                            </div>
                            <div className="oms-checkbox-item">
                                <input
                                    type="checkbox"
                                    id="Trending"
                                    checked={formData.categorytype?.includes("Trending")}
                                    onChange={(e) => updateTypeofCat("Trending", e.target.checked)}
                                />

                                <label htmlFor="Trending">Trending</label>
                            </div>
                        </div>
                    </div>


                    {/* Status */}
                    <div className="oms-form-group">
                        <label htmlFor="status" className="oms-form-label">
                            Status
                        </label>
                        <Select
                            options={statusOptions}
                            placeholder="Select status"
                            name="status"
                            value={formData.status}
                            onChange={handleSelectChange}
                        />
                    </div>

                    {/* Actions */}


                    <div className="oms-form-actions">
                        <button type="submit" className='post-property-submit'>Submit</button>
                    </div>
                </div>

            </form >
        </>
    );
};

export default AffiliateProductEdit;


